import axios from 'axios';
import { createStore } from 'vuex';

export default createStore({
    state: {
        token: localStorage.getItem('token') || null,
        user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
            localStorage.setItem('token', token); // Store token in localStorage
        },
        SET_USER(state, user) {
            state.user = user;
            localStorage.setItem('user', JSON.stringify(user));
        },

        logout(state) {
            state.token = '';
            state.user = {};
            state.isAuthenticated = false;
            localStorage.removeItem('token');
            localStorage.removeItem('user');
          },
      
    },
    actions: {


        async login({ commit }, { email, password }) {
            try {
              const response = await axios.post('/auth/login', { email, password });
              const token = response.data.token;
              const user = response.data.email;
              axios.defaults.headers.common['authorization'] = `Bearer ${token}`; // Set token globally

              commit('SET_TOKEN', token);
              commit('SET_USER', user);
              // You can fetch user data here (optional)
              // const userResponse = await axios.get('http://localhost:3000/api/auth/profile', {
              //   headers: { Authorization: `Bearer ${token}` }
              // });
              // commit('setUser', userResponse.data.user);
            //   console.log(response.data)
            //   console.log(response.status)
              return response;
            } catch (error) {
              throw new Error(error.response.data.message || 'Login failed');
            }
          },

          async alumnilogin({ commit }, { email, password }) {
            try {
              const response = await axios.post('/alumni/login', { email, password });
              const token = response.data.token;
              const user = response.data.user;
              axios.defaults.headers.common['authorization'] = `Bearer ${token}`; // Set token globally

              commit('SET_TOKEN', token);
              commit('SET_USER', user);
              // You can fetch user data here (optional)
              // const userResponse = await axios.get('http://localhost:3000/api/auth/profile', {
              //   headers: { Authorization: `Bearer ${token}` }
              // });
              // commit('setUser', userResponse.data.user);
            //   console.log(response.data)
            //   console.log(response.status)
              return response;
            } catch (error) {
              throw new Error(error.response.data.message || 'Login failed');
            }
          },
        
        async register({ commit }, { email, password }) {
            try {
                const response = await axios.post('/auth/register', { email, password });
                return response;
            } catch (error) {
                throw new Error(error.response.data.message || 'Registration failed');
            }
            },
        
      
        
            logout({ commit }) {
                commit('logout');
              },
    },
    getters: {
        user(state) {
            return state.user;
          },       
        isAuthenticated(state) {
            return !!state.token;
          },  
    },
});
